__turbopack_context__.v({
  "appBar": "layout-module__URsdqq__appBar",
  "appBarSearching": "layout-module__URsdqq__appBarSearching",
  "authButtons": "layout-module__URsdqq__authButtons",
  "backButton": "layout-module__URsdqq__backButton",
  "content": "layout-module__URsdqq__content",
  "contentInner": "layout-module__URsdqq__contentInner",
  "main": "layout-module__URsdqq__main",
  "search": "layout-module__URsdqq__search",
  "skipLink": "layout-module__URsdqq__skipLink",
  "visibleBackButton": "layout-module__URsdqq__visibleBackButton",
});
